import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for allConfigurations query
 */
export interface AllConfigsVariables {
  optionKey?: string;
  optionScope?: string;
}

/**
 * Configuration node structure
 */
export interface ConfigurationNode {
  id: string;
  optionKey: string;
  optionValue: string | null;
  optionScope: string;
}

/**
 * Configuration edge structure
 */
export interface ConfigurationEdge {
  node: ConfigurationNode;
}

/**
 * All configurations connection structure
 */
export interface AllConfigurationsConnection {
  edges: ConfigurationEdge[];
}

/**
 * Response structure for allConfigurations query
 */
export interface AllConfigsResponse {
  allConfigurations: AllConfigurationsConnection;
}

const allConfigs: DocumentNode = gql`
  query allConfigurations($optionKey: String, $optionScope: String) {
    allConfigurations(optionKey: $optionKey, optionScope: $optionScope) {
      edges {
        node {
          id
          optionKey
          optionValue
          optionScope
        }
      }
    }
  }
`;

export default allConfigs;
